var _defs, _circle, _circle2, _path, _rect, _rect2, _circle3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureScheduler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 16.858,
    cy: 14.328,
    r: 8.737,
    gradientTransform: "matrix(.944 0 0 .944 -6.212 -5.281)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#5c9fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#559ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#4a97e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#3990e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#2387de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#087bd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 17.97,
    cy: 15.337,
    r: 1.223,
    gradientTransform: "matrix(.943 0 0 .943 -7.203 -6.199)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e5e5e"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.71,
    cy: 8.252,
    r: 8.252,
    fill: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.742,
    cy: 8.252,
    r: 7.185,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7a7a7a",
    d: "M13.08 4.624l.87-.87.281.28-.87.87zM14.61 8.045h1.231v.397H14.61zM13.023 11.807l.28-.281.871.87-.28.281zM9.543 13.093h.397v1.231h-.397zM5.211 3.995l.28-.281.871.87-.28.281zM5.271 12.432l.87-.87.281.28-.87.871zM3.565 8.045h1.231v.397H3.565z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.237,
    y: 2.172,
    width: 1.107,
    height: 6.326,
    rx: 0.505,
    fill: "#7a7a7a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.722,
    y: 7.822,
    width: 1.105,
    height: 3.961,
    rx: 0.504,
    transform: "rotate(135 11.274 9.802)",
    fill: "#7a7a7a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.747,
    cy: 8.238,
    r: 1.169,
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.078.146A8.294 8.294 0 005.4 15.353l.274-.726a.161.161 0 01.275-.046l2.151 2.61a.161.161 0 01-.1.262L4.657 18a.162.162 0 01-.177-.216l.4-1.074a9.719 9.719 0 01-4.507-5.757A8.462 8.462 0 018.078.146z",
    fill: "#86d633"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureScheduler);
export default __webpack_public_path__ + "static/media/azure-scheduler.41f7eaebcf9498f381548e623edb6051.svg";
export { ForwardRef as ReactComponent };